import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Checkbox = styled.button`
  all: unset;
  box-sizing: border-box;

  width: 20px;
  height: 20px;
  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 6px;
  border: 1.5px solid ${props => props.checked ? theme.colors.green.Verde_AgroReceita : theme.colors.gray.Cinza_10};
  background-color: ${props => props.checked ? theme.colors.green.Verde_AgroReceita : theme.colors.white.Branco};

  cursor: ${props => props.disabled ? "not-allowed" : "pointer"};
  opacity: ${props => props.disabled ? 0.6 : 1};

  transition: background-color .15s ease, border-color .15s ease;
`;
